<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="520"
        :fullscreen="isMobile" persistent @keydown.esc="chiudi">
        <v-card>
            <v-card-title>{{ form.id ? 'Modifica annotazione' : 'Nuova annotazione' }}</v-card-title>
            <v-card-text>
                <v-form ref="formRef">
                    <v-text-field v-model="form.data" type="date" label="Data" :rules="[v => !!v || 'Campo obbligatorio']" />
                    <v-text-field v-model="form.titolo" label="Titolo (es. Cinghia di distribuzione)" />
                    <v-textarea v-model="form.testo" label="Annotazione" rows="4"
                        :rules="[v => !!(v || form.titolo) || 'Inserisci un titolo o un testo']" />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="primary" :loading="salvataggio" @click="salva">Salva</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogAnnotazioneMezzo",

    props: {
        modelValue: { type: Boolean, default: false },
        mezzoId: { type: [Number, String], required: true },
        annotazione: { type: Object, default: null },
    },
    emits: ["update:modelValue", "salvato"],

    data() {
        return {
            form: this.formVuoto(),
            salvataggio: false,
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
    },

    watch: {
        modelValue(val) {
            if (val) this.inizializza();
        },
    },

    methods: {
        // Data locale (non toISOString: in UTC sposterebbe il giorno vicino alla mezzanotte).
        oggiLocale() {
            const d = new Date();
            const m = String(d.getMonth() + 1).padStart(2, "0");
            const g = String(d.getDate()).padStart(2, "0");
            return `${d.getFullYear()}-${m}-${g}`;
        },

        formVuoto() {
            return { id: null, data: this.oggiLocale(), titolo: "", testo: "" };
        },

        inizializza() {
            this.form = this.annotazione
                ? {
                    id: this.annotazione.id,
                    data: this.annotazione.data ? this.annotazione.data.substr(0, 10) : this.oggiLocale(),
                    titolo: this.annotazione.titolo || "",
                    testo: this.annotazione.testo || "",
                }
                : this.formVuoto();
        },

        async salva() {
            const { valid } = await this.$refs.formRef.validate();
            if (!valid) return;

            this.salvataggio = true;
            try {
                const { id, ...dati } = this.form;
                dati.mezzoId = this.mezzoId;
                await this.$store.dispatch("annotazioniMezzo/salva", { id, dati, mezzoId: this.mezzoId });
                this.$emit("salvato");
                this.chiudi();
            } catch (error) {
                console.log(error);
            }
            this.salvataggio = false;
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },
    },
};
</script>
